export interface HeroImage {
  firstColumn: string
  secondColumn: string
}

export const heroImages: HeroImage[] = [
  {
    firstColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_01.png',
    secondColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_07.png',
  },
  {
    firstColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_02.png',
    secondColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_08.png',
  },
  {
    firstColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_03.png',
    secondColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_09.png',
  },
  {
    firstColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_13.jpg',
    secondColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_14.jpg',
  },
  {
    firstColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_05.png',
    secondColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_11.png',
  },
  {
    firstColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_06.png',
    secondColumn:
      'https://static.masterclass.com/vertical_scroll_hero_image_cropped_12.png',
  },
]

const IMAGE_WIDTH_DESKTOP = 285
const IMAGE_HEIGHT_DESKTOP = 356
const IMAGE_WIDTH_TABLET = 222
const IMAGE_HEIGHT_TABLET = 278
const IMAGE_WIDTH_MOBILE = 172
const IMAGE_HEIGHT_MOBILE = 215

export const IMAGE_RESOLUTIONS = {
  lg: {
    width: IMAGE_WIDTH_DESKTOP,
    height: IMAGE_HEIGHT_DESKTOP,
  },
  md: {
    width: IMAGE_WIDTH_TABLET,
    height: IMAGE_HEIGHT_TABLET,
  },
  sm: {
    width: IMAGE_WIDTH_MOBILE,
    height: IMAGE_HEIGHT_MOBILE,
  },
}
